export default "__VITE_ASSET__9abffd4b__"